export const getCacheSnapshot = () => {
  fetch('/proxy-news-frontend/news/get-caches-snapshot?ugc=true')
    .then((res) => res.json())
    .then((cache) => {
      const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(cache));
      const dlAnchorElem = document.createElement('a');
      dlAnchorElem.setAttribute('href', dataStr);
      dlAnchorElem.setAttribute('download', 'cache.json');
      document.body.appendChild(dlAnchorElem);
      dlAnchorElem.click();
    });
};
